import QuestionViewer from "modules/platform-components/question-viewer/QuestionViewer";
import React from "react";

function ExamModal({
  showWhereUsedGrid,
  setShowWhereUsedGrid,
  setShowViewQuestion,
  showViewQuestion,
  prevQuestion,
  nxtQuestion,
  QBCount,
  whereUsedPopupgridOptions,
  questionPopupData,
  currentQuestion,
  onSelect,
  manualQuestions,
  setCurrentQuestion
}) {
  return (
    <div
      id="myModalwhereUsed"
      className={`modal fade show`}
      role="dialog"
      data-backdrop="static"
      data-keyboard="false"
      style={{ display: showViewQuestion ? "block" : "" }}
    >
      <div className="modal-dialog modal-dialog-custom">
        <div className="modal-content" style={{ width: "135%", height: "auto" }}>
          <div className="modal-header modal-header-custom">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              onClick={() => {
                setShowWhereUsedGrid(false);
                setShowViewQuestion(false);
                setCurrentQuestion(null)
              }}
            >
              <div className="close-btn">
                <i className="fa fa-close" aria-hidden="true"></i>
              </div>
            </button>
          </div>
          <div className="modal-body modal-body-custom">
            <div>
              {showViewQuestion && (
                <div>
                  <QuestionViewer
                    prevQuestion={prevQuestion}
                    nxtQuestion={nxtQuestion}
                    count={QBCount}
                    whereUsedPopupgridOptions={whereUsedPopupgridOptions}
                    {...questionPopupData}
                    setId={currentQuestion}
                    selectable
                    onSelect={onSelect}
                    manualQuestions={manualQuestions}
                    showWhereUsedGrid={showWhereUsedGrid}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(ExamModal)